import { render, staticRenderFns } from "./KycMobileDefault.vue?vue&type=template&id=9e479d86&"
import script from "./KycMobileDefault.vue?vue&type=script&lang=js&"
export * from "./KycMobileDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports